import React, { useState, useEffect } from 'react';
import BoxWrapper from '../boxwra';
import ConfirmationDialog from '../../../Sales/TDSReconciliationSale/ConfirmationDailog';
import { Snackbar, Alert } from '@mui/material';

function Seven({ handleBack, updateTableData, data }) {
  const [tableData, setTableData] = useState(data);
  const [tableName, setTableName] = useState("7.Details of ITC Reversed and Ineligible ITC for the financial year");
  const [saveDailog, setSaveDailogOpen] = useState(false);
  const [unsavedChanges, setUnsavedChanges] = useState(false);
  const [confirmBack, setConfirmBack] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  // Update tableData when data prop changes
  useEffect(() => {
    setTableData(data);
  }, [data]);

  // Function to update tableData with calculated values
  const updateTableDataWithCalculations = (currentTableData) => {
    return currentTableData.map((item) => {
      const isSubTotalRow = [
        "(I) Total ITC Reversed (Sum of A to H above)",
        "(L) Sub-Total (H to K above)",
        "(M) Turnover on which tax is not to be paid (G + L) above",
        "(J) Net ITC Available for Utilization (6O - 7I)",
      ].includes(item.name);

      if (isSubTotalRow) {
        return {
          ...item,
          igst: getSubTotalRowValue(item, 'igst', currentTableData),
          cgst: getSubTotalRowValue(item, 'cgst', currentTableData),
          sgst: getSubTotalRowValue(item, 'sgst', currentTableData),
          cess: getSubTotalRowValue(item, 'cess', currentTableData),
        };
      }
      return item;
    });
  };

  const submitHandle = () => {
    // Update tableData with calculated values before saving
    const updatedTableData = updateTableDataWithCalculations(tableData);
    updateTableData(tableName, updatedTableData);
    setUnsavedChanges(false);
    setSaveDailogOpen(false);
    setSnackbarOpen(true);
  };

  const handleBackButton = () => {
    if (unsavedChanges) {
      setConfirmBack(true);
    } else {
      handleBack();
    }
  };

  const confirmBackHandle = () => {
    submitHandle();
    handleBack();
  };

    const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbarOpen(false);
  };

  // Helper function to safely parse values for calculations
  const safeParseFloat = (value) => {
    if (!value || value === '' || value === '-') {
      return 0; // Return 0 for incomplete values during typing
    }

    // Convert to string to safely use string methods
    const stringValue = String(value);
    if (stringValue.endsWith('.')) {
      return 0; // Return 0 for incomplete decimal values during typing
    }

    const parsed = parseFloat(value);
    return isNaN(parsed) ? 0 : parsed;
  };

  const formatRupee = (value, isManualInput = false) => {
    // For manual type fields, if value is empty, null, undefined, or 0, return empty string
    if (isManualInput && (!value || value === 0 || value === '0' || value === '0.00')) {
      return '';
    }

    if (!value && value !== 0) return '';

    // Check if the value has decimal places
    const hasDecimal = value.toString().includes('.');
    const decimalPlaces = hasDecimal ? value.toString().split('.')[1]?.length || 0 : 0;

    const formatter = new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      minimumFractionDigits: hasDecimal && decimalPlaces > 0 ? Math.min(decimalPlaces, 2) : 0,
      maximumFractionDigits: 2,
    });
    return formatter.format(value).replace('INR', '₹');
  };

  const parseRupee = (value) => {
    if (!value) return '';
    // Allow only digits, one decimal point, and optional leading negative sign
    let cleaned = value.replace(/[^0-9.-]/g, '');
    // Ensure only one decimal point
    const parts = cleaned.split('.');
    if (parts.length > 2) {
      cleaned = parts[0] + '.' + parts.slice(1).join('');
    }
    // Ensure only one negative sign at the beginning
    if (cleaned.startsWith('-')) {
      cleaned = '-' + cleaned.substring(1).replace(/-/g, '');
    } else {
      cleaned = cleaned.replace(/-/g, '');
    }
    return cleaned;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    const [itemName, field] = name.split('.');

    // Clean the input value but allow intermediate states like "-", "5.", etc.
    const cleanedValue = parseRupee(value);

    setTableData((prevData) =>
      prevData.map((item) =>
        item.name === itemName
          ? { ...item, [field]: cleanedValue }
          : item
      )
    );

    setUnsavedChanges(true);

    // Force re-render to update calculated subtotals when any manual input changes
    // setTimeout(() => {
    //   setTableData((prev) => [...prev]);
    // }, 0);
  };

  const getSubTotalRowValue = (item, key_name) => {
    let value = 0;
    const getVal = (idx) => safeParseFloat(tableData[idx]?.[key_name] || 0);

    switch (item.name) {
      case "(I) Total ITC Reversed (Sum of A to H above)":
        // A to H1 = indices 0 to 9 (10 rows)
        for (let i = 0; i < 10; i++) {
          value += getVal(i);
        }
        return value; // raw number

      case "(J) Net ITC Available for Utilization (6O - 7I)":
        const storedTableItemsJSON = localStorage.getItem('tableItems');
        const storedTableItems = storedTableItemsJSON ? JSON.parse(storedTableItemsJSON) : null;
        const sixO = storedTableItems?.six_o?.[key_name] || 0;
        // (I) is index 10 → calculate live
        let totalReversed = 0;
        for (let i = 0; i < 10; i++) {
          totalReversed += getVal(i);
        }
        return sixO - totalReversed; // raw number

      default:
        return value;
    }
  };

  // const getSubTotalRowValue = (item, key_name, dataToUse = tableData) => {
  //   let value = 0;
  //   switch (item.name) {
  //     case "(I) Total ITC Reversed (Sum of A to H above)":
  //       for (let i = 0; i < 9; i++) {
  //         value += safeParseFloat(dataToUse[i]?.[key_name] || 0);
  //       }
  //       return value.toFixed(2);
  //     case "(L) Sub-Total (H to K above)":
  //       for (let i = 7; i < 11; i++) {
  //         value += safeParseFloat(dataToUse[i]?.[key_name] || 0);
  //       }
  //       return value.toFixed(2);
  //     case "(M) Turnover on which tax is not to be paid (G + L) above":
  //       let l_value = 0;
  //       let g_value = 0;
  //       for (let i = 7; i < 11; i++) {
  //         l_value += safeParseFloat(dataToUse[i]?.[key_name] || 0);
  //       }
  //       for (let i = 0; i < 6; i++) {
  //         g_value += safeParseFloat(dataToUse[i]?.[key_name] || 0);
  //       }
  //       const value_1 = parseFloat(l_value) + parseFloat(g_value);
  //       return value_1.toFixed(2);
  //     case "(J) Net ITC Available for Utilization (6O - 7I)":
  //       const storedTableItemsJSON = localStorage.getItem('tableItems');
  //       const storedTableItems = storedTableItemsJSON ? JSON.parse(storedTableItemsJSON) : null;
  //       console.log("storedTableItems",storedTableItems);
        

  //       for (let i = 0; i < 8; i++) {
  //         value += safeParseFloat(dataToUse[i]?.[key_name] || 0);
  //           console.log(value);
  //       }

      
        

  //       const sixO = storedTableItems?.six_o?.[key_name] || 0;
  //       const res = parseFloat(sixO) - parseFloat(value);
  //       return res.toFixed(2);
  //   }
  //   return value.toFixed(2);
  // };

  const renderTableRows = () => {
    const getRowColor = (index) => {
      const colors = ['#e0e7ff', '#e9d5ff', '#f3e8ff', '#ede9fe', '#ddd6fe'];
      return colors[index % colors.length];
    };

    return tableData.map((item, index) => {
      const isSubTotalRow = [
        "(I) Total ITC Reversed (Sum of A to H above)",
        "(L) Sub-Total (H to K above)",
        "(M) Turnover on which tax is not to be paid (G + L) above",
        "(J) Net ITC Available for Utilization (6O - 7I)",
      ].includes(item.name);

      // Check if this is a manual input row (not a subtotal and has manual_type true)
      const isManualInputRow = !isSubTotalRow && (item.manual_type === true || item.manual_type === undefined);

      return (
        <div
          key={index}
          style={{
            display: 'grid',
            gridTemplateColumns: '60px 1fr 150px 150px 150px 150px',
            gap: '10px',
            alignItems: 'center',
            padding: '8px 10px',
            borderBottom: '1px solid #f1f5f9',
            backgroundColor: index % 2 === 0 ? '#ffffff' : '#f8fafc',
            borderRadius: '6px',
            marginBottom: '2px',
            minHeight: '50px',
          }}
        >
          <span
            style={{
              color: '#1e293b',
              fontSize: '13px',
              fontWeight: '600',
              textAlign: 'center',
              padding: '8px 6px',
              backgroundColor: getRowColor(index),
              borderRadius: '6px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            {index + 1}
          </span>
          <span
            style={{
              color: '#334155',
              fontSize: '13px',
              padding: '8px 12px',
              backgroundColor: '#f1f5f9',
              borderRadius: '6px',
              wordBreak: 'break-word',
              textAlign: 'left',
              display: 'flex',
              alignItems: 'center',
              minHeight: '34px',
            }}
          >
            {item.name}
          </span>
          {['igst', 'cgst', 'sgst', 'cess'].map((field, idx) => {
            // F and G rows: IGST and CESS non-editable (index 5, 6)
            const isForGRow = index === 7 || index === 8;
            const isForGNonEditable = isForGRow && (field === 'igst' || field === 'cess');
            
            // For editable fields, show raw value during editing; for display, format if valid number
            let displayValue;
            if (isForGNonEditable) {
              // Don't bind value for F and G rows IGST and CESS - show empty
              displayValue = '';
            } else if (isSubTotalRow) {
              displayValue = formatRupee(getSubTotalRowValue(item, field));
            } else if (isManualInputRow) {
              const rawVal = item[field];
              const numVal = safeParseFloat(rawVal);
              // Convert to string to safely use string methods
              const stringVal = String(rawVal || '');
              displayValue = (rawVal === '' || rawVal === '-' || stringVal.endsWith('.')) ? rawVal : formatRupee(numVal, true);
            } else {
              displayValue = formatRupee(item[field], isManualInputRow) || '';
            }

            return (
              <input
                key={`${item.name}.${field}`}
                type="text"
                className="blue-color"
                name={`${item.name}.${field}`}
                value={displayValue}
                onChange={handleInputChange}
                readOnly={isSubTotalRow || isForGNonEditable}
                style={{
                  color: '#1e293b',
                  fontWeight: '500',
                  fontSize: '13px',
                  textAlign: 'right',
                  padding: '8px 12px',
                  backgroundColor: isForGNonEditable ? '#d3d3d3' : (isSubTotalRow ? '#f0f0f0' : '#ecfdf5'),
                  border: '1px solid #e2e8f0',
                  borderRadius: '6px',
                  outline: 'none',
                  cursor: isSubTotalRow || isForGNonEditable ? 'not-allowed' : 'text',
                  minHeight: '34px',
                  boxSizing: 'border-box',
                  width: '100%',
                  ...(isSubTotalRow ? { fontWeight: 'bold', borderColor: 'green', borderWidth: '2px' } : {}),
                }}
                onFocus={(e) => {
                  if (!isSubTotalRow && isManualInputRow && !isForGNonEditable) {
                    // On focus, show raw value without formatting for easier editing
                    const rawVal = item[field] || '';
                    e.target.value = rawVal;
                    e.target.style.borderColor = '#88d8a3';
                    e.target.style.boxShadow = '0 0 0 2px rgba(136, 216, 163, 0.1)';
                  }
                }}
                onBlur={(e) => {
                  if (!isSubTotalRow && isManualInputRow && !isForGNonEditable) {
                    // On blur, re-format the value if it's a valid number
                    const rawVal = e.target.value;
                    const cleanedVal = parseRupee(rawVal);
                    const numVal = safeParseFloat(cleanedVal);
                    // Convert to string to safely use string methods
                    const stringVal = String(cleanedVal || '');
                    const finalDisplay = (cleanedVal === '' || cleanedVal === '-' || stringVal.endsWith('.')) ? cleanedVal : formatRupee(numVal, true);
                    e.target.value = finalDisplay;
                    // Update state with cleaned value
                    setTableData((prevData) =>
                      prevData.map((it) =>
                        it.name === item.name
                          ? { ...it, [field]: cleanedVal }
                          : it
                      )
                    );
                    e.target.style.borderColor = '#e2e8f0';
                    e.target.style.boxShadow = 'none';
                  }
                }}
              />
            );
          })}
        </div>
      );
    });
  };

  // Debug: Log current tableData to console
  useEffect(() => {
    console.log('Current tableData:', tableData);
  }, [tableData]);

  return (
    <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif' }}>
      <div
        style={{
          backgroundColor: 'white',
          borderRadius: '20px',
          padding: '30px',
          width: '100%',
          boxShadow: '0 20px 40px rgba(0,0,0,0.1)',
        }}
      >
        <BoxWrapper
          backButtonForZohoEnable={true}
          backButton={handleBackButton}
          boxTitle={tableName}
        >
          <p style={{ marginLeft: '10px' }}>
            <span style={{ fontWeight: 'bold' }}>Note: </span> The fields where the system computed values would be modified by more/less 20% shall be highlighted in <span style={{ color: 'red' }}>Red</span> for reference and attention.
          </p>
          <hr style={{ marginLeft: '10px' }} />
        </BoxWrapper>

        <div
          style={{
            maxHeight: 'calc(100vh - 450px)',
            overflowY: 'auto',
            marginTop: '10px',
          }}
        >
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: '60px 1fr 150px 150px 150px 150px',
              gap: '10px',
              alignItems: 'center',
              padding: '8px 10px',
              borderBottom: '2px solid #e2e8f0',
              backgroundColor: '#f8fafc',
              borderRadius: '6px',
              marginBottom: '2px',
              minHeight: '50px',
              fontWeight: '600',
              color: '#475569',
              fontSize: '13px',
              position: 'sticky',
              top: '0',
              zIndex: '10',
            }}
          >
            <span
              style={{
                textAlign: 'center',
                padding: '8px 6px',
                backgroundColor: '#e0e7ff',
                borderRadius: '6px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              S.No.
            </span>
            <span
              style={{
                textAlign: 'left',
                padding: '8px 12px',
                backgroundColor: '#f1f5f9',
                borderRadius: '6px',
                wordBreak: 'break-word',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              Description
            </span>
            <span
              style={{
                textAlign: 'right',
                padding: '8px 12px',
                backgroundColor: '#f1f5f9',
                borderRadius: '6px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end',
              }}
            >
              Integrated Tax (₹)
            </span>
            <span
              style={{
                textAlign: 'right',
                padding: '8px 12px',
                backgroundColor: '#f1f5f9',
                borderRadius: '6px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end',
              }}
            >
              Central Tax (₹)
            </span>
            <span
              style={{
                textAlign: 'right',
                padding: '8px 12px',
                backgroundColor: '#f1f5f9',
                borderRadius: '6px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end',
              }}
            >
              State/UT Tax (₹)
            </span>
            <span
              style={{
                textAlign: 'right',
                padding: '8px 12px',
                backgroundColor: '#f1f5f9',
                borderRadius: '6px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end',
              }}
            >
              CESS (₹)
            </span>
          </div>
          {tableData && tableData.length >= 1 ? (
            renderTableRows()
          ) : (
            <div style={{ textAlign: 'center', color: '#64748b', padding: '20px' }}>
              No Data Found!
            </div>
          )}
        </div>

        <div
          style={{
            marginTop: '20px',
            padding: '15px',
            backgroundColor: '#f8fafc',
            borderRadius: '8px',
            borderTop: '2px solid #e2e8f0',
          }}
        >
          <p style={{ margin: '0', fontSize: '14px', color: '#64748b', textAlign: 'center' }}>
            Total Records: {tableData?.length || 0}
          </p>
        </div>

        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            marginTop: '20px',
            gap: '10px',
          }}
        >
          <button
            type="button"
            className="button-primary"
            onClick={() => setSaveDailogOpen(true)}
            style={{
              padding: '10px 20px',
              background: 'linear-gradient(135deg, #ffd3a5 0%, #fd9853 50%, #e8a87c 100%)',
              color: 'white',
              border: 'none',
              borderRadius: '6px',
              fontSize: '14px',
              fontWeight: '600',
              cursor: 'pointer',
              boxShadow: '0 4px 12px rgba(255, 211, 165, 0.3)',
              transition: 'all 0.2s ease',
            }}
            onMouseOver={(e) => {
              e.target.style.transform = 'translateY(-1px)';
              e.target.style.boxShadow = '0 6px 16px rgba(255, 211, 165, 0.4)';
            }}
            onMouseOut={(e) => {
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '0 4px 12px rgba(255, 211, 165, 0.3)';
            }}
          >
            Save
          </button>
        </div>
      </div>

      <ConfirmationDialog
        open={saveDailog}
        onClose={() => setSaveDailogOpen(false)}
        onConfirm={submitHandle}
        title="Confirm Save"
        text="Do you want to save your changes? This action will update the current data."
      />

      <ConfirmationDialog
        open={confirmBack}
        onConfirm={confirmBackHandle}
        onClose={() => handleBack()}
        title="Unsaved Changes"
        text="You have unsaved changes. Do you want to leave without saving?"
      />

       <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000} // Auto-close after 3 seconds
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity="success"
          sx={{ width: '100%' }}
        >
         Data saved successfully!
        </Alert>
      </Snackbar>
    </div>
  );
}

export default Seven;